const $_default =
{
    minDate()
    {
        return null;
    },

    maxDate()
    {
        return null;
    },

    localeData()
    {
        return {};
    },

    ranges()
    {
        let today          = new Date(); today.setHours(0, 0, 0, 0);
        let todayEnd       = new Date(); todayEnd.setHours(23, 59, 59, 999);
        let yesterdayStart = new Date(); yesterdayStart.setDate(today.getDate() - 1); yesterdayStart.setHours(0, 0, 0, 0);
        let yesterdayEnd   = new Date(); yesterdayEnd.setDate(today.getDate() - 1); yesterdayEnd.setHours(23, 59, 59, 999);
        let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        let thisMonthEnd   = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999);

        return (
        {
            'Today'      : [ today, todayEnd ],
            'Yesterday'  : [ yesterdayStart, yesterdayEnd ],
            'This month' : [ thisMonthStart, thisMonthEnd ],
            'This year'  : [ new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999) ],
            'Last month' : [ new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999) ],
        });
    },

    calculatePosition( dropdownList, component, { width, top, left, right, direction } )
    {
        if( component.opens === 'center' )    { dropdownList.style.left = ( left + width / 2 ) + 'px'; }
        else if (component.opens === 'left')  { dropdownList.style.left = left + 'px'; }
        else if (component.opens === 'right') { dropdownList.style.left = right + 'px'; }
        else if( component.opens === 'full' )
        {
            dropdownList.style.left      = '50%';
            dropdownList.style.top       = '50%';
            dropdownList.style.transform = 'translate(-50%, -50%)';

            return;
        }

        /*
        let dropdownClientRect = dropdownList.getBoundingClientRect();

        console.log({ width, top, left, right, direction });
        console.log('box', dropdownList.getBoundingClientRect());
        console.log('w', window.innerWidth);

        if( dropdownClientRect.x + dropdownClientRect.width > window.innerWidth )
        {
            dropdownList.style.left = `calc(${ parseInt( dropdownList.style.left ) - ( dropdownClientRect.x + dropdownClientRect.width - window.innerWidth ) }px - ( var(--scale) * 24px ))`;
        }
        */

        if( !dropdownList.classList.contains( direction ) )
        {
            dropdownList.classList.remove('top', 'bottom');
            dropdownList.classList.add( direction );
        }

        dropdownList.style.top = top + ( direction === 'top' ? 12 : -12 ) + 'px';
    }
}

const $_validator =
{

}

export default
{
    props:
    {
        modelValue              : { type: Object, default: { startDate: null, endDate: null }, required: true },
        class                   : { type: String, default: '' },
        dropdownClass           : { type: String, default: '' },
        placeholder             : { type: String, default: '' }, // Equivalent to the `placeholder` attribute on an `<input>`.
        minDate                 : { type: [ String, Date ], default: $_default.minDate }, // Minimum date allowed to be selected
        maxDate                 : { type: [ String, Date ], default: $_default.maxDate }, // Maximum date allowed to be selected
        showWeekNumbers         : { type: Boolean, default: false }, // Show the week numbers on the left side of the calendar
        linkedCalendars         : { type: Boolean, default: true }, // Each calendar has separate navigation when this is false
        singleDatePicker        : { type: [ Boolean, String ], default: false }, // Only show a single calendar, with or without ranges. [( true || 'single' => one calendar | no range ), ( 'range' => one calendar | range ), ( false => double calendar | range )]
        showDropdowns           : { type: Boolean, default: false }, // Show the dropdowns for month and year selection above the calendars
        timePicker              : { type: Boolean, default: false }, // Show the dropdowns for time (hour/minute) selection below the calendars
        timePickerIncrement     : { type: Number, default: 5 }, // Determines the increment of minutes in the minute dropdown
        timePicker24Hour        : { type: Boolean, default: true }, // Use 24h format for the time
        timePickerSeconds       : { type: Boolean, default: false }, // Allows you to select seconds except hour/minute
        autoApply               : { type: Boolean, default: false }, // Auto apply selected range. If false you need to click an apply button
        localeData              : { type: Object, default: $_default.localeData }, // Object containing locale data used by the picker. See example below the table
        //dateRange               : { type: Object, default: null, required: true }, // This is the v-model prop which the component uses. This should be an object containing startDate and endDate props.
        opens                   : { type: String, default: 'center' }, // Which way the picker opens - "center", "left", "right" or "inline"
        dateFormat              : { type: Function }, // function(classes, date) - special prop type function which accepts 2 params: ( "classes" - the classes that the component's logic has defined ) | ( "date" - tha date currently processed )
        alwaysShowCalendars     : { type: Boolean, default: true }, // If set to false and one of the predefined ranges is selected then calendars are hidden. | If no range is selected or you have clicked the "Custom ranges" then the calendars are shown.
        disabled                : { type: Boolean, default: false }, // Disabled state. If true picker do not popup on click.
        appendToBody            : { type: Boolean, default: true }, // Append the dropdown element to the end of the body
        closeOnEsc              : { type: Boolean, default: true }, // Whether to close the dropdown on "esc"
        readonly                : { type: Boolean }, // Makes the picker readonly. No button in footer. No ranges. Cannot change.
        ranges                  : { type: [ Object, Boolean ], default: $_default.ranges }, // You can set this to false in order to hide the ranges selection. Otherwise it is an object with key/value. See below
        calculatePosition       : { type: Function, default: $_default.calculatePosition } // When `appendToBody` is true, this function is responsible for positioning the drop down list.
    }
}